import useErrorStore, { CustomError } from '../../../stores/error-store';

/**
 * Creates a helper function to handle API errors in a consistent way
 * @returns A function to handle errors with the error store
 */
export const useErrorHandler = () => {
  const errorStore = useErrorStore();

  /**
   * Handles an error by passing it to the error store
   * @param error The error object
   * @param message Optional override message
   */
  const handleError = (error: any, message?: string) => {
    const customError: CustomError = {
      code: error?.code || 500,
      message: message || error?.message || 'An error occurred',
    };

    errorStore.handleOpenErrorDialog(customError, 'Status Message API');
  };

  return { handleError };
};